import { apiPost } from '@/store/api';

export interface EmailGenerationStatus {
  DQU_QUEUE_STATUS: number;
  DQU_DOCUMENT_ID?: number | null;
  TITLE?: string;
}

export function isEmailGenerationStatus(value: unknown): value is EmailGenerationStatus {
  return value !== null && typeof value === 'object'
    && 'DQU_QUEUE_STATUS' in value && typeof value.DQU_QUEUE_STATUS === 'number'
    && (!('DQU_DOCUMENT_ID' in value) || value.DQU_DOCUMENT_ID == null || typeof value.DQU_DOCUMENT_ID === 'number')
    && (!('TITLE' in value) || value.TITLE === undefined || typeof value.TITLE === 'string');
}

export async function getEmailGenerationStatus(guid: string): Promise<EmailGenerationStatus> {
  const result: unknown = await apiPost(`document/email-status/${guid}`);
  const status = result !== null && typeof result === 'object' && 'payload' in result ? result.payload : result;
  if (!isEmailGenerationStatus(status)) throw new Error('Invalid email generation status response.');
  return status;
}